import React from 'react';

import AdjusterCommunicationsV3Wrapper from './AdjusterCommunicationsPageV3';

export default function AdjusterCommunications() {
  return <AdjusterCommunicationsV3Wrapper />;
}
